export default __webpack_public_path__ + "static/media/serenaelis.46c767b0.png";